import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app.routing";
import { ComponentsModule } from "./components/components.module";
import { AppComponent } from "./app.component";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { ConfigEnvService } from "./shared/configEnvService";
import { AuthGuard } from "./shared/auth-guard";

export function configProviderFactory(provider: ConfigEnvService) {
  return () => provider.load();
}

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
  ],
  declarations: [AppComponent, AdminLayoutComponent],
  providers: [
    AuthGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: configProviderFactory,
      deps: [ConfigEnvService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
